exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding-left[_v-5f4dd030]{padding-left:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5f4dd030&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/User/Previous-purchases.vue
// module id = 436
// module chunks = 0